import MuiTableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import StyledTableCell from './StyledTableCell';

import { Checkbox, Stack } from '@mui/material';

import { useState } from 'react';
import MenuActions from './MenuActions';

function TableHead(props) {
  const [checked, setChecked] = useState(false)
  const handleCheckboxChange = (event, rows) => {
    setChecked(event.target.checked)
    const isChecked = event.target.checked;

    if (!isChecked) {
      props.setSelectedRows([])
    } else {
      props.setSelectedRows(rows.map(e => e.id))
    }
  };

  /* const [openMenu, setOpenMenuActions] = React.useState(null); */
  /*  const handleOpenMenu = (event) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  }; */

  const { headers, color, sortTable } = props;

  return (
    <MuiTableHead>
      <TableRow>
        {headers.map((header, index) => (
          <StyledTableCell
            key={`table-head-cell-${header.id}`}
            align={'center' /* index > 0 ? 'right' : 'left' */}
            color={color}
          >
            <Stack
              direction="row"
              alignItems={'center'}
              spacing={4}
              justifyContent="center"
            >
              {header.checkbox ? <Checkbox onChange={(e) => handleCheckboxChange(e, props?.rows)} checked={checked} sx={{
                color: "white", '&.Mui-checked': {
                  color: 'white',
                },
              }} /> : null}
              {header.label}
              {header.sort ? (
                <MenuActions
                  rows={[
                    {
                      text: `Ordenar ${header.label} de manera ascendente`,
                      icon: 'ArrowUpward',
                      handler: () => sortTable(header.id, 'asc'),
                      isDisabled: false,
                    },
                    {
                      text: `Ordenar ${header.label} de manera descendente`,
                      icon: 'ArrowDownward',
                      handler: () => sortTable(header.id, 'desc'),
                      isDisabled: false,
                    },
                  ]}
                />
              ) : null}
            </Stack>
          </StyledTableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  );
}

export default TableHead;
